import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import DatePicker from "react-datepicker";
import TextField from '@mui/material/TextField';
import "react-datepicker/dist/react-datepicker.css";
import $ from "jquery";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import Dropdown from "react-dropdown";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import "react-dropdown/style.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useCallback, useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import DropBox from "../../custom/DropBox";
import ShowImage from "../../custom/ShowImage";
import { showDangerToast } from "../../constants/toaster";
import { s3 } from "../../constants/awsConfig";
const imageFileTypes = ["image/png", "image/gif", "image/jpeg"];
const otherFileTypes = [".arscene", ".videofx"];

export const AddRewardInfo = (props) => {
    useEffect(() => {
        if (props?.bannerFormData?.id) {
            if (props.bannerImage) {
                props.setThumbanailControl({
                    showError: false,
                    errorMessage: "",
                    showImage: props?.bannerFormData?.imageUrl ? true : false,
                    imageData: { src: props?.bannerFormData?.imageUrl },
                });
            }
        }
    }, [props.show]);
    const [viewOrder, setViewOrder] = useState(0)
    const [value, setValue] = useState("USER");
    const [images, setImages] = useState([]);

    const handleChange = event => {
        setValue(event.target.value)
        props?.setBannerFormData({
            ...props?.bannerFormData,
            type: event.target.value
        })
    }

    const uploadFileToAWS = async (selectedFile) => {
        console.log(1);
        if (!selectedFile) return;
        console.log(2);

        const params = {
            Bucket: 'praxo-dev-cloud-front', // bucket name
            Key: `uploads/${selectedFile.name}`,
            Body: selectedFile,
            ContentType: selectedFile.type,
            // ACL: 'public-read', // Adjust according to your needs
        };

        try {
            const data = await s3.upload(params).promise();
            console.log('Upload Success', data.Location);
            const url = data.Location.replace(
                "https://praxo-dev-cloud-front.s3.ap-south-1.amazonaws.com/",
                "https://dhwdwg726vpm7.cloudfront.net/"
            );
            console.log(url, 'url');
            return { success: true, url: url }
        } catch (error) {
            console.error('Error uploading file:', error);
            return { success: false }
        }
    };


    const handleSubmit = async () => {
        console.log(props?.bannerFormData)
        if (props?.bannerFormData?.id) {
            if (
                props?.bannerFormData?.viewOrder &&
                props?.bannerFormData?.type
            ) {
                if (props?.bannerImage) {
                    const isImageUploaded = await uploadFileToAWS(props.bannerImage)
                    if (isImageUploaded.success) {
                        props.onSubmit(isImageUploaded.url);
                    } else {
                        showDangerToast("Image upload failed.");
                    }
                } else {
                    if (props?.thumbanailControl.imageData?.src) {
                        props.onSubmit(props?.thumbanailControl.imageData?.src);
                    } else {
                        showDangerToast("Thumbnail is required.");
                    }
                }
            } else {
                showDangerToast("Please fill all required Fields.");
            }
        } else {
            if (
                props?.bannerFormData?.viewOrder &&
                props?.bannerFormData?.type &&
                props?.bannerImage
            ) {
                const isImageUploaded = await uploadFileToAWS(props.bannerImage)
                if (isImageUploaded.success) {
                    props.onSubmit(isImageUploaded.url);
                } else {
                    showDangerToast("Image upload failed.");
                }
            } else {
                showDangerToast("Please fill all required Fields.");
            }
        }
    };

    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.map((file, index) => {
            if (imageFileTypes.includes(file.type)) {
                const reader = new FileReader();
                reader.onload = function (e) {
                    setImages((prevState) => [
                        ...prevState,
                        { id: index, src: e.target.result },
                    ]);
                    props?.setBannerImage(file);
                    props.setThumbanailControl({
                        showError: false,
                        errorMessage: "",
                        showImage: true,
                        imageData: { id: index, src: e.target.result },
                    });
                };
                reader.readAsDataURL(file);

                return file;
            } else {
                props.setThumbanailControl({
                    showError: true,
                    errorMessage: "Only Image file is accept. ",
                    showImage: false,
                    imageData: [],
                });
            }
        });
    }, []);

    useEffect(() => {
        if (props?.show && props?.bannerFormData) {
            setValue(props.bannerFormData.type || 'USER')
            setViewOrder(props.bannerFormData.viewOrder ?? 0)
            props.setThumbanailControl({
                showError: false,
                errorMessage: '',
                showImage: props?.bannerFormData?.imageUrl ? true : false,
                imageData: { src: props?.bannerFormData?.imageUrl },
            })
            props.setFilterFileControl({
                showError: false,
                errorMessage: '',
                showImage: true,
                imageData: { src: props?.bannerFormData?.imageUrl },
            })
        }
    }, [props?.show, props?.bannerFormData?.id])

    const clickToRemove = () => {
        props?.setBannerImage(null)
    }

    // console.log("props?.thumbanailControl", props?.thumbanailControl);

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props?.bannerFormData?.id ? "Update Reward Info" : "Add Reward Info"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                </div>
                <div className="row mt-3">
                    <div className="col-md-6">
                        Upload Thumbnail*
                        <DropBox
                            onDrop={onDrop}
                            acceptType="image/*"
                            isImage={true}
                            thumbanailControl={props?.thumbanailControl}
                            setThumbanailControl={props?.setThumbanailControl}
                            clickToRemove={clickToRemove}
                        />
                        {props.thumbanailControl?.showError ? (
                            <label className="custom-error-label" style={{ color: "red" }}>
                                {" "}
                                {props.thumbanailControl?.errorMessage}
                            </label>
                        ) : (
                            <></>
                        )}
                        {props?.bannerFormData?.id ? (
                            <></>
                        ) : props?.bannerImage === null ? (
                            <label className="custom-error-label">
                                Thumbnail is required*
                            </label>
                        ) : (
                            <></>
                        )}
                    </div>
                    <div className="col-md-6">
                        <div className="row col-md-12 mt-2">
                            <FormControl>
                                <FormLabel id="demo-row-radio-buttons-group-label">Select Type*</FormLabel>
                                <RadioGroup
                                    row
                                    value={value}
                                    onChange={handleChange}
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel value="USER" control={<Radio />} label="User" />
                                    <FormControlLabel value="INFLUENCER" control={<Radio />} label="Influencer" />
                                    <FormControlLabel value="SHOPPING" control={<Radio />} label="Shopping" />
                                </RadioGroup>
                            </FormControl>
                        </div>
                        <div className="row col-md-12 mt-4">
                            <FormControl fullWidth>
                                <TextField
                                    label="Title"
                                    value={props?.bannerFormData?.title || ''}
                                    onChange={(e) =>
                                        props?.setBannerFormData({
                                            ...props?.bannerFormData,
                                            title: e.target.value
                                        })
                                    }
                                />
                            </FormControl>
                        </div>
                        <div className="row col-md-12 mt-4">
                            <FormControl fullWidth>
                                <TextField
                                    label="Description"
                                    multiline
                                    minRows={3}
                                    value={props?.bannerFormData?.description || ''}
                                    onChange={(e) =>
                                        props?.setBannerFormData({
                                            ...props?.bannerFormData,
                                            description: e.target.value
                                        })
                                    }
                                />
                            </FormControl>
                        </div>
                        <div className="row col-md-12 mt-4">
                            <FormControl>
                                <TextField label="View Order" id="outlined-size-normal" value={viewOrder} onChange={(e) => {
                                    // Use a regular expression to check if the input is numeric
                                    const numericRegex = /^[0-9\b]+$/
                                    // Check if the input value matches the numeric regex
                                    if (
                                        numericRegex.test(e.target.value) ||
                                        e.target.value === ''
                                    ) {
                                        setViewOrder(e.target.value)
                                        props?.setBannerFormData({
                                            ...props?.bannerFormData,
                                            viewOrder: e.target.value
                                        })
                                    }
                                }} />
                            </FormControl>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outlined" onClick={props.onHide}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit}>Submit</Button>
            </Modal.Footer>
        </Modal>
    );
};
